let logToConsole = true

const idSplitter = (id) => {
  return id.split('-').join('')
}
const setAmplitudeUserID = (id) => {
  if (!window.amplitude) {
    return
  }
  if (id) {
    window.amplitude.getInstance().setUserId(idSplitter(id))
    if (logToConsole) {
      console.log(`%c 💬 Amplitude set User ID: ${idSplitter(id)}`, 'color: lightblue background: black')
    }
  }
}
const logAmplitudeEvent = (data) => {
  if (!window.amplitude) {
    return
  }
  window.amplitude.getInstance().logEvent(data.event, data.eventProperties)
  if (logToConsole) {
    console.log(`%c 💬 Amplitude event: ${data.event}, params:`, 'color: lightblue background: black', data.eventProperties)
  }
}
export {setAmplitudeUserID, logAmplitudeEvent}



// WEBPACK FOOTER //
// ./src/utils/amplitude.js